import $ from "jquery";
import Foundation from 'foundation-sites';

/**
 * Foundation
 *
 * To import a new component from Foundation, import the module and activate the plugin.
 * 
 * First add Foundation core:
 *     import { Foundation } from "foundation-sites/js/foundation.core";
 *
 * Next, for example:
 *     import { Accordion } from 'foundation-sites/js/foundation.accordion';
 *     Foundation.plugin(Accordion, 'Accordion');
 *
 * See this file for more component options:
 *     foundation-sites/js/entries/foundation;
 */

Foundation.addToJquery($);
$(document).foundation();
